import { computed, watch, watchEffect } from 'vue'
import { useOnline } from '@vueuse/core'
import { useRoute } from 'vue-router'
import { useAppParams } from '@/stores/app'
import { reportBackMode } from '@/bridge'
import type { BackMode } from '@/bridge'

/** 安全区 CSS 变量注入：JS 运行时把 RN 传入的真实 px 写到 :root，postcss 不处理 var()，保持物理 px */
export function useSafeAreaInjection() {
  const params = useAppParams()
  watchEffect(() => {
    document.documentElement.style.setProperty('--inset-top', `${params.inset_top}px`)
    document.documentElement.style.setProperty('--inset-bottom', `${params.inset_bottom}px`)
  })
}

/** 返回手势上报：仅 backMode 变化时发 setBackEnabled */
export function useBackGestureReporter() {
  const route = useRoute()
  const backMode = computed<BackMode>(() => (route.meta?.backMode as BackMode) ?? 'allow')
  watch(backMode, (m) => reportBackMode(m, route.path), { immediate: true })
}

/** 离线检测：已加载过的页面直接进入，未加载过的页面需有网络（在线状态用 VueUse useOnline，响应式） */
export function useOfflineGuard() {
  const route = useRoute()
  const isOnline = useOnline()
  const loadedPages = new Set<string>()
  const isOffline = computed(() => !loadedPages.has(route.path) && !isOnline.value)
  watch(
    () => route.path,
    (p) => {
      if (isOnline.value) loadedPages.add(p)
    },
    { immediate: true },
  )
  return { isOffline }
}
